import React, { useState } from 'react';
import Toast from './toast';

import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@mui/material';

const TempPassDialog = ({ tempPassOpen, setTempPassOpen, username, tempPassword }) => {

	const [toast, setToast] = useState({
		open: false,
		severity: 'info',
		message: '',
		clickToClose: true,
		duration: 3000,
	});

	// Copy the temporary password to the clipboard
	const copyToClipboard = (text) => {
		navigator.clipboard.writeText(text);
		setToast({
			open: true,
			severity: 'info',
			message: 'Temporary password copied to clipboard',
			clickToClose: true,
			duration: 2000,
		});
	}

	// Close the dialog, but prevent closing on backdrop click
	const handleTempPassClose = (event, reason) => {
		if (reason === 'backdropClick') {
			return;
		}
		setTempPassOpen(false);
	}

	return (
		<>
			<Toast
				severity={toast.severity}
				message={toast.message}
				toastOpen={toast.open}
				setToastOpen={() => setToast({ ...toast, open: false })}
				clickToClose={toast.clickToClose}
				duration={toast.duration}
			/>
			<Dialog
				open={tempPassOpen}
				onClose={handleTempPassClose}
				aria-labelledby="form-dialog-title"
				maxWidth='sm'
				sx={{
					'.MuiDialog-paper': {
						border: '5px solid #B1282E',
						borderRadius: 3
					},
				}}
			>
				<DialogTitle id="form-dialog-title">
					<Typography variant="h5" component="div" fontFamily='Saira, sans-serif' fontWeight={600} textAlign='center' sx={{ flexGrow: 1 }}>
						{username === '' ? 'User' : username}'s Temporary Password
					</Typography>
				</DialogTitle>
				<DialogContent>
					<Typography component="div" fontFamily='Saira, sans-serif' sx={{ marginLeft: 2, flexGrow: 1 }}>
						The new user account has been created and a temporary password has been generated for them. Please provide the following temporary password to the new user:
					</Typography>
					<Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginY: 1, marginX: 10 }}>
						<Box sx={{ textAlign: 'center', bgcolor: 'lightgray', paddingX: 1, marginY: 1 }}>
							<Typography variant='h5' component='div' fontFamily='Saira, sans-serif' fontWeight={600}>
								{tempPassword}
							</Typography>
						</Box>
						<Box sx={{ textAlign: 'center', marginY: 0 }}>
							<Button onClick={() => copyToClipboard(tempPassword)} variant='outlined' size='small'>
								Copy to Clipboard
							</Button>
						</Box>
					</Box>
				</DialogContent>
				<DialogActions sx={{ justifyContent: 'center', paddingBottom: 3 }}>
					<Button onClick={() => setTempPassOpen(false)} variant='contained' size='medium'>
						I've saved the temporary password
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

export default TempPassDialog;